// pt-BR strings for the Plan 7 'processoTabs' namespace (t('processoTabs.…')), kept apart so each screen's strings live in one file.
export const processoTabsPt = {
  breadcrumb: 'Processos',
  overdue_one: '1 prazo vencido',
  overdue_other: '{{count}} prazos vencidos',
  title: '{{type}} nº {{number}}',
  titleDate: '{{title}} ({{date}})',
  tablist: 'Módulos do processo',
  tabs: {
    linha: 'Linha do tempo',
    anm: 'Dados ANM',
    ambiental: 'Ambiental',
    territorio: 'Território',
    sei: 'SEI',
    financeiro: 'Financeiro',
  },
  actNow: 'exige ação',
  locked: 'módulo não contratado',
  lockedTitle: 'Disponível com o módulo {{module}}',
  lockedCta: 'Ver planos',
  modules: { ambiental: 'Ambiental', territorio: 'Território', sei: 'SEI' },
  lockedBody: {
    ambiental: 'Com o módulo Ambiental você acompanha as licenças e os pedidos nos órgãos ambientais, os imóveis do CAR e as restrições ambientais sobre a área.',
    territorio: 'Com o módulo Território você vê os imóveis certificados (SIGEF) sob o processo, os assentamentos do INCRA e os territórios quilombolas sobre a área.',
  },
  timeline: {
    filters: 'Filtrar por fonte',
    all: 'Todas',
    raw: 'texto original',
  },
  anm: {
    loading: 'Carregando os dados do Cadastro Mineiro…',
    failed: 'Não foi possível carregar os dados do Cadastro Mineiro agora. Tente de novo em alguns minutos.',
    basics: 'Dados básicos',
    process: 'Processo',
    nup: 'NUP',
    phase: 'Fase',
    requestType: 'Tipo de requerimento',
    regionalUnit: 'Superintendência',
    protocolAt: 'Protocolo',
    priorityAt: 'Prioridade',
    area: 'Área',
    situation: 'Situação',
    active: 'Ativo',
    inactive: 'Inativo',
    substancesTitle: 'Substâncias e municípios',
    substance: 'Substância',
    use: 'Uso',
    since: 'Desde',
    until: 'Até',
    current: 'atual',
    endedBecause: 'encerrada: {{reason}}',
    municipalities: 'Municípios',
    noSubstances: 'Nenhuma substância registrada no Cadastro Mineiro.',
    noMunicipalities: 'Nenhum município registrado.',
    people: 'Pessoas',
    name: 'Nome',
    document: 'CPF/CNPJ',
    relation: 'Relação',
    noPeople: 'Nenhuma pessoa relacionada ao processo no Cadastro Mineiro.',
    titles: 'Títulos',
    titleType: 'Título',
    titleNumber: 'Nº',
    published: 'Publicado',
    status: 'Situação',
    expires: 'Vencimento',
    noTitles: 'Nenhum título outorgado registrado.',
    associations: 'Processos associados',
    associationType: 'Associação',
    otherProcess: 'Processo',
    note: 'Observação',
    noAssociations: 'Nenhum processo associado (cessão, arrendamento, grupamento mineiro…) no Cadastro Mineiro.',
    soil: 'Condição de propriedade do solo',
    noSoil: 'O Cadastro Mineiro não registra a condição do solo deste processo.',
    soilNote: 'Os imóveis rurais sobre a área estão na aba Território.',
    filings: 'Documentos protocolados',
    filedOn: 'Data',
    subject: 'Documento',
    via: 'Via',
    pd: 'Protocolo Digital',
    noFilings: 'Nenhum documento protocolado pelo Protocolo Digital.',
    filingsNote: 'Os documentos no SEI estão na aba SEI.',
  },
  ambiental: {
    empty: 'Nenhum órgão ambiental acompanhado para a UF deste processo ainda — nenhuma licença ou pedido a mostrar.',
  },
  territorio: {
    noRestrictions: 'Nenhuma restrição sobre a área',
    noParcels: 'Nenhum imóvel certificado (SIGEF) ou declarado no CAR sob o processo.',
    superficiarios: 'Superficiários da carteira →',
  },
  financeiro: {
    empty: 'Nada de TAH, dívida ativa, CFEM ou multas nos dados abertos da ANM para este processo.',
  },
  aside: 'Resumo do processo',
  deadlines: {
    title: 'Prazos',
    all: 'em Atividades →',
    none: 'Nenhum prazo aberto neste processo.',
  },
  facts: {
    title: 'Dados principais',
    phase: 'Fase',
    substance: 'Substância',
    municipality: 'Município',
    uf: 'UF',
    area: 'Área',
    protocol: 'Protocolo',
    lastEvent: 'Última movimentação',
  },
  teasers: {
    title: 'Neste processo',
    licences: 'Licenças ambientais',
    licencesExpired_one: '{{total}} · 1 vencida',
    licencesExpired_other: '{{total}} · {{count}} vencidas',
    requests: 'Pedidos em andamento',
    parcels: 'Imóveis sobre a área',
    restrictions: 'Restrições',
    restrictionsNone: 'nenhuma',
    sei: 'Documentos no SEI',
    cfem: 'CFEM {{year}}',
    lockedValue: 'com o módulo',
  },
} as const;
